import { useEffect, useRef, useState } from 'react'

export function useTextSelection(inputRef?: React.RefObject<HTMLElement>) {
  const [selectedText, setSelectedText] = useState('')
  const [selectionRects, setSelectionRects] = useState<DOMRect[]>([])
  const [isAskButtonVisible, setAskButtonVisible] = useState(false)
  const lastSelectionRef = useRef<Range | null>(null)

  useEffect(() => {
    const handleSelection = (event: MouseEvent | KeyboardEvent) => {
      const selection = window.getSelection()
      const selected = selection?.toString().trim()

      const inputEl = inputRef?.current
      const activeEl = document.activeElement
      const target = event.target as HTMLElement

      if (
        typeof target?.className === 'string' &&
        target.className.includes('ant-dropdown')
      ) {
        return
      }

      if (inputEl && activeEl && inputEl.contains(activeEl)) return

      if (selected && selection?.rangeCount) {
        const range = selection.getRangeAt(0).cloneRange()
        lastSelectionRef.current = range
        setSelectedText(selected)
        setSelectionRects(Array.from(range.getClientRects()))
        setAskButtonVisible(true)
      } else {
        setSelectedText('')
        setSelectionRects([])
        setAskButtonVisible(false)
        lastSelectionRef.current = null
      }
    }

    document.addEventListener('mouseup', handleSelection)
    document.addEventListener('keyup', handleSelection)

    return () => {
      document.removeEventListener('mouseup', handleSelection)
      document.removeEventListener('keyup', handleSelection)
    }
  }, [inputRef])

  return {
    selectedText,
    selectionRects,
    isAskButtonVisible,
    setAskButtonVisible,
    setSelectedText,
    setSelectionRects,
    lastSelectionRef,
  }
}
